<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// TODO: replace filters with sets

export default {
  name: 'App',
};
</script>

<style>
body { margin: 0; }
#app {
  font-family: Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
}
.spacer {
  flex-grow: 1;
}
</style>
